import axios from 'axios'
import apiConfig from '../../../../../config/api-config'

const estimateLoyaltyPoints = ({
  items, memberType, accessToken, cartTotal, itemSku,
}) => {
  const payload = {
    memberType: memberType ? 2 : 1,
    items: items.map(item => ({
      sku: item?.product?.sku || item?.sku || '',
      part: item?.product?.part?.name || item?.partname,
      brand: item?.product?.brand?.name || item?.brandText,
      category: item?.product?.category || item?.categorytext || '',
      quantity: item?.modifiers?.quantity || item?.qty || 1,
      ...item?.itemTotalUnitPrice ? {
        amount: Math.round(item?.itemTotalUnitPrice * 100),
      } : {
        amount: Math.round(item?.price?.regular * (item.modifiers.quantity || item?.qty || 1) * 100),
      },
      ...itemSku && { discountAmount: (Number(itemSku?.find(i => (i?.sku === item?.product?.sku || i?.sku === item?.sku))?.discount) || 0) * 100 },
    })),
    cartTotal: Math.round((cartTotal || 0) * 100),
  }

  return axios.post(
    `${apiConfig.apiURL}/loyalty/v1/loyalty/preview`,
    payload,
    { headers: { apikey: apiConfig.apiKey, accessToken } },
  )
}

export default estimateLoyaltyPoints
